module.exports = __webpack_public_path__ + "img/lock.1b3f94dc.svg";